import { appModule } from '@/store/modules/ModuleApp';
import { IUserData, userModule } from '@/store/modules/ModuleUser';
import { SUPPLIER_SHARE_EVENT_NAME, SUPPLIER_SHARE_PREFIX, SUPPLIER_SHARE_DOMAIN, CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE } from '@/libs/LibsStatus';

/** 跨域同步操作类型 */
export type CrossDomainSyncOpType = 'get' | 'set' | 'onChange';

/**
 * 上报跨域同步操作埋点（统一封装）
 * 所有 sync.get / sync.set / sync.onChange 调用统一通过本方法上报。
 *
 * @param type 操作类型：'get' | 'set' | 'onChange'
 * @param key 操作 key
 * @param value 操作 value（get 为读取到的值；set 为写入值；onChange 为变更后的新值）
 */
export function reportCrossDomainSyncOperation(type: CrossDomainSyncOpType, key: string, value: string): void {
	const windowObj: any = window;
	try {
		if (!windowObj.pgvSendClick) {
			console.log('前端监控脚本未加载成功！');

			return;
		}

		// 仅取核心用户信息节点：appModule.userData.UserInfoList[0].userInfo
		const userData: any = (userModule && userModule.userData) || {};
		// const userInfo: any = (userData.UserInfoList && userData.UserInfoList[0] && userData.UserInfoList[0].userInfo) || {};
		/** 展开 userData 全部字段，并将 null/undefined 兜底为空字符串 */
		const supplierInfo: Record<string, any> = Object.keys(userData).reduce((acc: Record<string, any>, k: string) => {
			const v: any = userData[k];
			acc[k] = v === null || typeof v === 'undefined' ? '' : v;

			return acc;
		}, {});

		const cookieKey: string = CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE;
		/** 拼接到 hotTag 中的业务数据对象 */
		const payload: Record<string, any> = {
			supplierInfo,
			type,
			key: cookieKey,
			value,
			perfix: SUPPLIER_SHARE_PREFIX,
			domain: SUPPLIER_SHARE_DOMAIN
		};

		console.log(`${SUPPLIER_SHARE_EVENT_NAME}${JSON.stringify(payload)}`, '监听日志');

		windowObj.pgvSendClick({
			hotTag: `${SUPPLIER_SHARE_EVENT_NAME}${JSON.stringify(payload)}`
		});
	} catch (e) {
		console.log(e);
	}
}